import { render, staticRenderFns } from "./addSecondBook.vue?vue&type=template&id=b2d11594&scoped=true&"
import script from "./addSecondBook.vue?vue&type=script&lang=js&"
export * from "./addSecondBook.vue?vue&type=script&lang=js&"
import style0 from "./addSecondBook.vue?vue&type=style&index=0&id=b2d11594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d11594",
  null
  
)

export default component.exports